export const UPDATE_ITEM_LIST_SLIDER = 'UPDATE_ITEM_LIST_SLIDER';
